exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Toastify__toast{border-radius:5px;padding-left:15px;min-height:unset}.Toastify__toast-container{width:40%;margin-left:-20%;height:40px}\n", ""]);

// exports
